import React from 'react';
import cn from 'classnames';
import './Icon.scss';


export default React.createClass({
    getDefaultProps() {
        return {
            size: '1em'
        };
    },
    build(name, options) {
        // If the SVG you're trying to add has a key different from value that looks
        // like a big block of mumbo-jumbo, odds are it will work as the "value" key.
        const icon = icons[name];
        const {shapes, style} = icon;
        return (
            <svg viewBox={icon.view_box} className={cn('svg-icon', 'icon--' + name, options.classes)} style={{width: options.size, height: options.size, ...style}} role="img" {...options}>
                <title id="title">{icon.title}</title>
                {shapes && shapes.map(s => s)}
                {icon.paths && icon.paths.map((p, i) => <path key={i} {...p} d={p.value}></path> )}
            </svg>
        );
    },
    render() {
        const {name} = this.props;
        if (!(name in icons)) {
            if (window.console) {
                console.warn(`${JSON.stringify(name)} is not a valid icon name`);
            }
            return null;
        }
        return this.build(name, this.props);
    }
});


const icons = {
    home: {
        title: 'Home Icon',
        view_box: "0 0 12 12",
        paths: [
            {
                value: "M12,5.987l-6,-5.987l-6,5.987l0,0.386l1.503,0l0,3.738l3.366,0l0,-2.621l2.249,0l0,2.621l3.379,0l0,-3.738l1.503,0l0,-0.386Z"
            }
        ],
    },
    search: {
        title: 'Magnifying Glass Icon',
        view_box: "0 0 24 24",
        paths: [
            {
                value: "M15.5 14h-0.795l-0.275-0.275c0.98-1.135 1.57-2.61 1.57-4.225 0-3.59-2.91-6.5-6.5-6.5s-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5c1.615 0 3.090-0.59 4.225-1.565l0.275 0.275v0.79l5 4.99 1.49-1.49-4.99-5zM9.5 14c-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5 4.5 2.015 4.5 4.5-2.015 4.5-4.5 4.5z"
            }
        ],
    },
    user: {
        title: "Person/User Icon",
        view_box: '0 0 20 20',
        paths: [
            {
                value: "M16.667 15.278h-0.032c-0.254-1.163-2.052-2.648-4.968-3.073v-0.955h-0.102c0.889-0.804 1.768-2.191 1.768-4.167 0-2.302-0.833-4.167-3.333-4.167s-3.333 1.865-3.333 4.167c0 1.976 0.879 3.363 1.768 4.167h-0.102v0.955c-2.917 0.425-4.714 1.909-4.968 3.073h-0.032c0 0.031 0.011 0.063 0.019 0.094-0.008 0.062-0.019 0.124-0.019 0.183h0.112c0.523 0.693 2.896 1.528 6.555 1.528s6.032-0.835 6.555-1.528h0.112c0-0.058-0.011-0.121-0.019-0.183 0.008-0.032 0.019-0.063 0.019-0.094z"
            }
        ],
    },
    menu: {
        view_box: '0 0 16 16',
        title: 'Menu Icon',
        paths: [
            {
                value: 'M15,2.00443c0,-0.547763 -0.444049,-0.991812 -0.991812,-0.991812l-12.0164,4.44089e-16c-0.547763,0 -0.991812,0.444049 -0.991812,0.991812l0,0.0163765c0,0.547763 0.444049,0.991812 0.991812,0.991812l12.0164,-4.44089e-16c0.547763,0 0.991812,-0.444049 0.991812,-0.991812l0,-0.0163765Z',
            },
            {
                value: 'M15,6.01262c0,-0.552285 -0.447715,-1 -1,-1l-12,8.88178e-16c-0.552285,0 -1,0.447715 -1,1c0,0.552285 0.447715,1 1,1l12,0c0.552285,0 1,-0.447715 1,-1Z',
            },
            {
                value: 'M15,10.0126c0,-0.552285 -0.447715,-1 -1,-1l-12,0c-0.552285,0 -1,0.447715 -1,1c0,0.552285 0.447715,1 1,1l12,0c0.552285,0 1,-0.447715 1,-1Z',
            },
            {
                value: 'M15,14.0126c0,-0.552285 -0.447715,-1 -1,-1l-12,0c-0.552285,0 -1,0.447715 -1,1c0,0.552285 0.447715,1 1,1l12,0c0.552285,0 1,-0.447715 1,-1Z',
            }
        ]
    },
    wide_menu: {
        view_box: '0 0 12 12',
        title: 'Menu Icon',
        paths: [
            {
                value: 'M0,1.752l12,0l0,1.723l-12,0l0,-1.723ZM0,8.525l12,0l0,1.723l-12,0l0,-1.723ZM0,5.208l12,0l0,1.733l-12,0l0,-1.733Z',
            }
        ]
    },
    more: {
        view_box: '0 0 24 24',
        title: 'More icon',
        paths: [
            {
                value: 'M12 8c1.105 0 2-0.895 2-2s-0.895-2-2-2-2 0.895-2 2 0.895 2 2 2zM12 10c-1.105 0-2 0.895-2 2s0.895 2 2 2 2-0.895 2-2-0.895-2-2-2zM12 16c-1.105 0-2 0.895-2 2s0.895 2 2 2 2-0.895 2-2-0.895-2-2-2z',
            }
        ]
    },
    new_window: {
        view_box: '0 0 12 12',
        title: 'Open Link in New Window Icon',
        paths: [
            {
                value: 'M6.742,7.132l-0.73,-0.729l4.243,-4.229l-3.516,0l0.01,-1.032l5.226,0.003l0.025,5.224l-1.075,0.01l0,-3.397l-4.183,4.15Z',
            },
            {
                value: 'M9.869,6.369l0,4.489c-3.641,0 -6.227,0 -9.869,0l0,-7.629l6.739,0l-1.069,1.086l-4.584,0c0,1.552 0,3.906 0,5.458l7.698,0l0,-2.186l1.085,-1.218Z',
            }
        ]
    },
    multi_choice: {
        view_box: '0 0 16 16',
        title: 'Multiple-choice Icon',
        paths: [
            {
                value: 'M6.25128,1.87949l8.74359,0l0,1.74872l-8.74359,0l0,-1.74872ZM6.25128,7.12564l8.74359,0l0,1.74872l-8.74359,0l0,-1.74872ZM6.25128,12.3718l8.74359,0l0,1.74872l-8.74359,0l0,-1.74872ZM1.00513,2.75385c0,-0.965784 0.782934,-1.74872 1.74872,-1.74872c0.965784,0 1.74872,0.782934 1.74872,1.74872c0,0.965784 -0.782934,1.74872 -1.74872,1.74872c-0.965784,0 -1.74872,-0.782934 -1.74872,-1.74872ZM1.00513,8c0,-0.965784 0.782934,-1.74872 1.74872,-1.74872c0.965784,0 1.74872,0.782934 1.74872,1.74872c0,0.965784 -0.782934,1.74872 -1.74872,1.74872c-0.965784,0 -1.74872,-0.782934 -1.74872,-1.74872ZM1.00513,13.2462c0,-0.965784 0.782934,-1.74872 1.74872,-1.74872c0.965784,0 1.74872,0.782934 1.74872,1.74872c0,0.965784 -0.782934,1.74872 -1.74872,1.74872c-0.965784,0 -1.74872,-0.782934 -1.74872,-1.74872Z',
            }
        ]
    },
    empty_circle: {
        view_box: '0 0 16 16',
        title: 'Empty Circle Icon',
        shapes: [
            <circle fill="transparent" cx="8" cy="8" r="7" />
        ],
        paths: [
            {
                value: 'M8,2.6c3,0,5.5,2.5,5.5,5.5S11,13.6,8,13.6s-5.5-2.5-5.5-5.5S5,2.6,8,2.6 M8,1.1c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S11.9,1.1,8,1.1L8,1.1z',
            }
        ]
    },
    half_filled_circle: {
        view_box: '0 0 16 16',
        title: 'Half-filled Circle Icon',
        paths: [
            {
                value: 'M8,15c-0.3277,-0.00207437 -0.654285,-0.0224807 -0.978959,-0.0679118c-0.655979,-0.0917901 -1.29824,-0.277568 -1.9018,-0.550445c-1.35994,-0.614847 -2.50536,-1.66832 -3.23354,-2.97091c-0.334336,-0.598077 -0.579739,-1.24522 -0.725491,-1.91474c-0.110189,-0.506157 -0.19141,-0.977977 -0.188012,-1.49599c0.00165946,-0.252985 0.0447133,-0.552469 0.0734422,-0.803791c0.0819206,-0.716647 0.275544,-1.41968 0.57271,-2.07696c0.347551,-0.768723 0.835406,-1.4725 1.4319,-2.06899c0.616589,-0.616589 1.3478,-1.11696 2.14676,-1.46649c0.826218,-0.361444 1.72092,-0.558654 2.62231,-0.581479c0.908041,-0.0229941 1.81843,0.129529 2.66769,0.45239c0.816885,0.310556 1.57298,0.776069 2.21963,1.3638c0.623307,0.566515 1.14356,1.24504 1.52756,1.99477c0.326892,0.638223 0.554124,1.32658 0.671331,2.03401c0.0606858,0.366284 0.103638,0.781381 0.105937,1.15275c0.00229945,0.371371 -0.0360538,0.699017 -0.0921282,1.06603c-0.104173,0.681825 -0.310219,1.34739 -0.60962,1.96876c-0.660116,1.36998 -1.76949,2.50618 -3.12296,3.19941c-0.5862,0.300247 -1.21478,0.516611 -1.86165,0.640545c-0.318876,0.0610943 -0.640874,0.0976636 -0.964897,0.116143c-0.120098,0.00532578 -0.240005,0.00834739 -0.360219,0.00910836ZM2.95389,8l10.0462,0c0.00117875,-0.22274 -0.0122863,-0.418464 -0.0403608,-0.639344c-0.0621577,-0.489034 -0.197373,-0.968246 -0.400469,-1.41745c-0.248425,-0.549465 -0.597367,-1.05237 -1.02371,-1.47872c-0.440659,-0.440661 -0.963108,-0.798551 -1.53413,-1.04836c-0.609604,-0.266682 -1.27107,-0.407267 -1.93623,-0.415682c-0.668102,-0.00845185 -1.33591,0.115565 -1.95465,0.368362c-0.577367,0.235896 -1.10863,0.581345 -1.55997,1.01166c-0.436153,0.415834 -0.796865,0.909971 -1.05848,1.45291c-0.213319,0.442715 -0.360085,0.916876 -0.434306,1.40266c-0.0433114,0.283482 -0.0857465,0.522747 -0.103863,0.763947Z',
            }
        ]
    },
    filled_circle: {
        view_box: '0 0 16 16',
        title: 'Filled Circle Icon',
        shapes: [
            <circle cx="8" cy="8" r="7" />
        ]
    },
    check: {
        view_box: '0 0 18 16',
        title: 'Checkmark Icon',
        paths: [
            {
                value: 'M3.61538,5.30769l-3.23077,3.23077l6.46154,6.46154l10.7692,-10.7692l-3.23077,-3.23077l-7.53846,7.53846l-3.23077,-3.23077Z',
            }
        ]
    },
    star: {
        view_box: '0 0 24 24',
        title: 'Solid star',
        paths: [
            {
                value: 'M12 17.27l6.18 3.73-1.64-7.030 5.46-4.73-7.19-0.61-2.81-6.63-2.81 6.63-7.19 0.61 5.46 4.73-1.64 7.030z'
            }
        ]
    },
    star_outline: {
        view_box: '0 0 24 24',
        title: 'Star outline',
        paths: [
            {
                value: 'M22 9.24l-7.19-0.62-2.81-6.62-2.81 6.63-7.19 0.61 5.46 4.73-1.64 7.030 6.18-3.73 6.18 3.73-1.63-7.030 5.45-4.73zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-0.38 1.7-4.030 1.71 4.040 4.38 0.38-3.32 2.88 1 4.28-3.77-2.28z',
            }
        ]
    },
    double_star: {
        view_box: '0 0 12 12',
        title: 'Double Star Icon',
        paths: [
            {
                value: 'M6,0.306l1.023,3.147l1.971,-0.972l-0.316,2.175l3.309,0l-2.677,1.945l1.534,1.574l-2.166,0.372l1.022,3.147l-2.677,-1.945l-1.023,1.945l-1.023,-1.945l-2.677,1.945l1.022,-3.147l-2.166,-0.372l1.534,-1.574l-2.677,-1.945l3.309,0l-0.316,-2.175l1.971,0.972l1.023,-3.147Z',
            }
        ]
    },
    x: {
        view_box: '0 0 16 16',
        title: 'X Shaped Icon',
        paths: [
            {
                value: 'M14.996,12.2053l-4.20075,-4.20075l4.20075,-4.20075l-2.7953,-2.7953l-4.20075,4.20075l-4.20075,-4.20075l-2.7953,2.7953l4.20075,4.20075l-4.20075,4.20075l2.7953,2.7953l4.20075,-4.20075l4.20075,4.20075l2.7953,-2.7953Z',
            }
        ]
    },
    edit: {
        view_box: '0 0 1024 1024',
        title: 'Edit Icon',
        paths: [
            {
                value: 'M128 736v160h160l472.107-472.107-160-160-472.107 472.107zM883.413 300.587c16.64-16.64 16.64-43.733 0-60.373l-99.627-99.627c-16.64-16.64-43.733-16.64-60.373 0l-78.080 78.080 160 160 78.080-78.080z',
            }
        ]
    },
    circle_with_x: {
        view_box: '0 0 12 12',
        title: 'X Inside Filled Circle Icon',
        paths: [
            {
                value: 'M6,0c-3.313,0 -6,2.686 -6,6c0,3.313 2.687,6 6,6c3.313,0 6,-2.687 6,-6c0,-3.313 -2.687,-6 -6,-6ZM8.968,7.907l-1.061,1.061l-1.907,-1.908l-1.907,1.908l-1.061,-1.061l1.908,-1.907l-1.908,-1.907l1.061,-1.061l1.907,1.907l1.907,-1.907l1.061,1.061l-1.908,1.907l1.908,1.907Z',
            }
        ]
    },
    menu_down: {
        view_box: '0 0 24 24',
        title: 'Menu arrow down',
        paths: [
            {
                value: 'M7.415 8.21l4.585 4.585 4.585-4.585 1.415 1.415-6 6-6-6z',
            }
        ]
    },
    sort_unsorted: {
        view_box: '0 0 1024 1024',
        paths: [
            {
                value: 'M512-12.8l-235.52 373.76h470.989l-235.469-373.76zM512.051 1011.2l235.469-373.76-471.040-0.051 235.571 373.811z',
            }
        ]
    },
    sort_descending: {
        view_box: '0 0 1024 1024',
        paths: [
            {
                value: 'M747.52 294.451l-471.040-0.051 235.52 409.6z',
            }
        ]
    },
    sort_ascending: {
        view_box: '0 0 1024 1024',
        paths: [
            {
                value: 'M276.48 704h471.040l-235.571-409.6z',
            }
        ]
    },
    arrow_left: {
        view_box: '0 0 16 16',
        title: 'Arrow Pointing Left Icon',
        paths: [
            {
                value: 'M8,10.45l0,4.55l-7,-7l7,-7l0,4.55l7,0l0,4.9l-7,0Z',
            }
        ]
    },
    circle_with_arrow_left: {
        view_box: '0 0 16 16',
        title: 'Arrow Pointing Left Inside Filled Circle Icon',
        paths: [
            {
                value: 'M8,16c-4.41828,1.77636e-15 -8,-3.58172 -8,-8c0,-4.41828 3.58172,-8 8,-8c4.41828,-3.55271e-15 8,3.58172 8,8c3.55271e-15,4.41828 -3.58172,8 -8,8ZM8.97725,13.7143l2.28571,-2.28571l-3.42857,-3.42857l3.42857,-3.42857l-2.28571,-2.28571l-5.71429,5.71429l5.71429,5.71429Z',
            }
        ]
    },
    arrow_right: {
        view_box: '0 0 16 16',
        title: 'Arrow Pointing Left Icon',
        paths: [
            {
                value: 'M8,5.55l-1.77636e-15,-4.55l7,7l-7,7l-1.77636e-15,-4.55l-7,1.77636e-15l-1.77636e-15,-4.9l7,-3.55271e-15Z',
            }
        ]
    },
    circle_with_arrow_right: {
        view_box: '0 0 16 16',
        title: 'Arrow Pointing Right Inside Filled Circle Icon',
        paths: [
            {
                value: 'M8,2.22045e-16c4.41827,0 8,3.58173 8,8c0,4.41827 -3.58173,8 -8,8c-4.41827,0 -8,-3.58173 -8,-8c0,-4.41827 3.58173,-8 8,-8l0,-4.44089e-16ZM7.02275,2.28571l-2.28571,2.28571l3.42857,3.42857l-3.42857,3.42857l2.28571,2.28571l5.71429,-5.71429l-5.71429,-5.71429l1.77636e-15,0Z',
            }
        ]
    },
    arrow_circle: {
        view_box: '0 0 16 16',
        title: 'Circular Arrow Icon',
        paths: [
            {
                value: 'M12.0145,8.2434c1.77636e-15,2.21299 -1.79949,4.01449 -4.01449,4.01449c-2.21499,0 -4.01449,-1.8015 -4.01449,-4.01449c0,-2.21299 1.79949,-4.01449 4.01449,-4.01449l1.18377,0.0135489l-0.584108,0.584108l1.41912,1.41912l3.01689,-3.0204l-3.01689,-3.01087l-1.41912,1.41912l0.592137,0.588123l-1.1918,4.44089e-16c-3.3245,4.44089e-16 -6.02173,2.69523 -6.02173,6.02173c8.88178e-16,3.32651 2.69724,6.02173 6.02173,6.02173c3.3245,0 6.02173,-2.69523 6.02173,-6.02173l-2.00724,0l0,3.55271e-15Z',
            }
        ]
    },
    circle_with_triangle: {
        view_box: '0 0 16 16',
        title: 'Triangle Inside Filled Circle Icon',
        paths: [
            {
                value: 'M6.163,12.526l0,-9.058l5.243,4.532l-5.243,4.526ZM8,0c-4.415,0 -8,3.585 -8,8c0,4.415 3.585,8.001 8,8.001c4.415,0 8,-3.586 8,-8.001c0,-4.415 -3.585,-8 -8,-8'
            }
        ]
    },
    circle_horz_bar: {
        view_box: '0 0 12 12',
        title: 'Circle with Horizontal Bar Icon',
        paths: [
            {
                value: 'M6,0c3.311,0 6,2.689 6,6c0,3.311 -2.689,6 -6,6c-3.311,0 -6,-2.689 -6,-6c0,-3.311 2.689,-6 6,-6ZM9.746,4.876l-7.492,0l0,2.248l7.492,0l0,-2.248Z',
            }
        ]
    },
    circle_help: {
        view_box: '0 0 1024 1024',
        title: 'Question Mark icon',
        paths: [
            {
                value: 'M512.079,80.5c-238.592,0 -432,193.408 -432,432c0,238.592 193.408,432 432,432c238.592,0 432,-193.408 432,-432c0,-238.592 -193.408,-432 -432,-432ZM512.079,848.5c-185.568,0 -336,-150.432 -336,-336c0,-185.568 150.432,-336 336,-336c185.568,0 336,150.432 336,336c0,185.568 -150.432,336 -336,336ZM512,680c26.119,0 48,21.881 48,48c0,26.119 -21.881,48 -48,48c-26.119,0 -48,-21.881 -48,-48c0,-26.119 21.881,-48 48,-48ZM512.079,252.894c47.324,0 87.887,16.902 121.69,50.705c33.803,33.802 50.704,74.366 50.704,121.69c0,36.507 -21.633,74.028 -64.901,112.563c-33.404,29.751 -53.914,47.285 -61.529,72.603c-3.722,12.375 -16.942,30.09 -41.232,29.96c-30.75,-0.164 -48.132,-27.569 -41.636,-53.819c7.368,-29.774 31.905,-55.941 59.214,-73.082c16.206,-10.172 31.098,-22.648 44.62,-37.521c13.521,-14.873 20.281,-31.775 20.281,-50.704c0,-22.986 -8.789,-42.93 -26.366,-59.831c-17.577,-16.902 -37.859,-25.352 -60.845,-25.352c-22.986,0 -43.268,8.45 -60.845,25.352c-10.135,9.745 -16.9,20.675 -21.64,32.27c-3.259,7.975 -14.356,26.571 -39.881,26.885c-28.942,0.355 -50.896,-28.663 -39.911,-58.697c8.355,-22.842 21.884,-43.615 40.587,-62.317c33.803,-33.803 74.366,-50.705 121.69,-50.705l0,0Z',
            }
        ]
    },
    circle_warn: {
        view_box: '0 0 1024 1024',
        title: 'Exclamation Point icon',
        paths: [
            {
                value: 'M512,80c-238.592,0 -432,193.408 -432,432c0,238.592 193.408,432 432,432c238.592,0 432,-193.408 432,-432c0,-238.592 -193.408,-432 -432,-432ZM512,848c-185.568,0 -336,-150.432 -336,-336c0,-185.568 150.432,-336 336,-336c185.568,0 336,150.432 336,336c0,185.568 -150.432,336 -336,336ZM513,253c-26.496,0 -48,21.472 -48,48l0,290.984c0,26.496 21.504,48 48,48c26.496,0 48,-21.504 48,-48l0,-290.984c0,-26.528 -21.504,-48 -48,-48l0,0ZM512,680c-26.496,0 -48,21.504 -48,48c0,26.496 21.504,48 48,48c26.496,0 48,-21.504 48,-48c0,-26.496 -21.504,-48 -48,-48Z',
            }
        ]
    },
    circle_add: {
        view_box: '0 0 1024 1024',
        title: 'Add Item icon',
        paths: [
            {
                value: 'M512 928c-229.76 0-416-186.24-416-416s186.24-416 416-416 416 186.24 416 416-186.24 416-416 416zM512 192c-176.704 0-320 143.264-320 320 0 176.704 143.296 320 320 320 176.736 0 320-143.296 320-320 0-176.736-143.264-320-320-320zM639.616 544h-96v96c0 17.696-14.336 32-32 32-17.696 0-32-14.304-32-32v-96h-96c-17.696 0-32-14.336-32-32s14.304-32 32-32h96v-96c0-17.696 14.304-32 32-32 17.664 0 32 14.304 32 32v96h96c17.664 0 32 14.336 32 32s-14.336 32-32 32z',
            }
        ]
    },
    circle_check: {
        view_box: '0 0 1024 1024',
        title: 'Circle with a checkmark icon',
        paths: [
            {
                value: 'M698.24 416.96l-32.064-32.064c-5.92-5.92-15.488-5.92-21.376 0l-192.448 192.416-91.488-92.224c-5.952-5.92-15.488-5.92-21.44 0l-32.064 32.096c-5.92 5.92-5.92 15.488 0 21.376l134.176 135.136c5.92 5.888 15.488 5.888 21.376 0l235.328-235.328c5.952-5.92 5.952-15.488 0-21.408zM512 96c-229.76 0-416 186.24-416 416s186.24 416 416 416 416-186.24 416-416-186.24-416-416-416zM512 832c-176.704 0-320-143.296-320-320 0-176.736 143.296-320 320-320 176.736 0 320 143.264 320 320 0 176.704-143.264 320-320 320z',
            }
        ]
    },
    square_check: {
        view_box: '0 0 1024 1024',
        title: 'Square check-box',
        paths: [
            {
                value: 'M810.667 128h-597.333c-47.36 0-85.333 38.4-85.333 85.333v597.333c0 46.933 37.973 85.333 85.333 85.333h597.333c47.36 0 85.333-38.4 85.333-85.333v-597.333c0-46.933-37.973-85.333-85.333-85.333zM426.667 725.333l-213.333-213.333 60.16-60.16 153.173 152.747 323.84-323.84 60.16 60.587-384 384z',
            }
        ]
    },
    folder: {
        view_box: '0 0 29 28',
        title: 'folder-open',
        paths: [
            {
                value: 'M29.359 14.875q0 0.484-0.484 1.031l-5.25 6.188q-0.672 0.797-1.883 1.352t-2.242 0.555h-17q-0.531 0-0.945-0.203t-0.414-0.672q0-0.484 0.484-1.031l5.25-6.188q0.672-0.797 1.883-1.352t2.242-0.555h17q0.531 0 0.945 0.203t0.414 0.672zM24 9.5v2.5h-13q-1.469 0-3.078 0.742t-2.562 1.867l-5.344 6.281q0-0.063-0.008-0.195t-0.008-0.195v-15q0-1.437 1.031-2.469t2.469-1.031h5q1.437 0 2.469 1.031t1.031 2.469v0.5h8.5q1.437 0 2.469 1.031t1.031 2.469z',
            }
        ]
    },
    printer: {
        view_box: '0 0 1024 1024',
        title: 'Printer icon',
        paths: [
            {
                value: 'M810.667 341.333h-597.333c-70.613 0-128 57.387-128 128v256h170.667v170.667h512v-170.667h170.667v-256c0-70.613-57.387-128-128-128zM682.667 810.667h-341.333v-213.333h341.333v213.333zM810.667 512c-23.68 0-42.667-18.987-42.667-42.667s18.987-42.667 42.667-42.667c23.68 0 42.667 18.987 42.667 42.667s-18.987 42.667-42.667 42.667zM768 128h-512v170.667h512v-170.667z',
            }
        ]
    },
    play: {
        view_box: '0 0 16 16',
        title: 'Play Media Icon',
        paths: [
            {
                value: 'M8,0.688128c-4.03824,0 -7.31187,3.27363 -7.31187,7.31187c0,4.03824 3.27363,7.31187 7.31187,7.31187c4.03824,0 7.31187,-3.27363 7.31187,-7.31187c0,-4.03824 -3.27363,-7.31187 -7.31187,-7.31187ZM8,13.9409c-3.28106,0 -5.9409,-2.65984 -5.9409,-5.9409c0,-3.28106 2.65984,-5.9409 5.9409,-5.9409c3.28106,0 5.9409,2.65984 5.9409,5.9409c0,3.28106 -2.65984,5.9409 -5.9409,5.9409ZM6.17203,4.80106l5.4839,3.19894l-5.4839,3.19894l0,-6.39789Z',
            }
        ]
    },
    audio: {
        view_box: '0 0 16 16',
        title: 'Audio Icon',
        paths: [
            {
                value: 'M0.770281,5.59009l0,4.81981l3.21321,0l4.01651,4.01651l0,-12.8528l-4.01651,4.01651l-3.21321,0ZM11.6149,8c0,-1.42184 -0.819368,-2.64286 -2.00826,-3.23731l0,6.46658c1.18889,-0.586411 2.00826,-1.80743 2.00826,-3.22927ZM9.6066,0.95504l0,1.6548c2.32154,0.69084 4.01651,2.84369 4.01651,5.39016c0,2.54647 -1.69497,4.69932 -4.01651,5.39016l0,1.6548c3.22124,-0.731005 5.62312,-3.60683 5.62312,-7.04496c0,-3.43813 -2.40187,-6.31396 -5.62312,-7.04496l0,-4.44089e-16Z',
            }
        ]
    },
    speech_bubble: {
        view_box: '0 0 12 12',
        title: 'Speech Bubble Icon',
        paths: [
            {
                value: 'M1.2,0l9.6,0c0.663,0 1.194,0.537 1.194,1.2l0.006,10.8l-2.4,-2.4l-8.4,0c-0.663,0 -1.2,-0.537 -1.2,-1.2l0,-7.2c0,-0.663 0.537,-1.2 1.2,-1.2ZM9.6,4.2l-7.2,0l0,1.2l7.2,0l0,-1.2ZM2.409,7.2l5.09,0l0,-1.2l-5.09,0l0,1.2ZM2.4,3.6l7.2,0l0,-1.2l-7.2,0l0,1.2Z',
            }
        ]
    },
    gear: {
        view_box: '0 0 1024 1024',
        title: 'Gear Icon',
        paths: [
            {
                value: 'M829.013 553.6c1.707-13.653 2.987-27.52 2.987-41.6s-1.28-27.947-2.987-41.6l90.24-70.613c8.107-6.4 10.453-17.92 5.12-27.307l-85.333-147.84c-5.333-9.173-16.427-13.013-26.027-9.173l-106.24 42.88c-21.973-16.853-46.080-31.147-72.107-42.027l-16-113.067c-1.92-10.027-10.667-17.92-21.333-17.92h-170.667c-10.667 0-19.413 7.893-21.12 17.92l-16 113.067c-26.027 10.88-50.133 24.96-72.107 42.027l-106.24-42.88c-9.6-3.627-20.693 0-26.027 9.173l-85.333 147.84c-5.333 9.173-2.987 20.693 5.12 27.307l90.027 70.613c-1.707 13.653-2.987 27.52-2.987 41.6s1.28 27.947 2.987 41.6l-90.027 70.613c-8.107 6.4-10.453 17.92-5.12 27.307l85.333 147.84c5.333 9.173 16.427 13.013 26.027 9.173l106.24-42.88c21.973 16.853 46.080 31.147 72.107 42.027l16 113.067c1.707 10.027 10.453 17.92 21.12 17.92h170.667c10.667 0 19.413-7.893 21.12-17.92l16-113.067c26.027-10.88 50.133-24.96 72.107-42.027l106.24 42.88c9.6 3.627 20.693 0 26.027-9.173l85.333-147.84c5.333-9.173 2.987-20.693-5.12-27.307l-90.027-70.613zM512 661.333c-82.56 0-149.333-66.773-149.333-149.333s66.773-149.333 149.333-149.333 149.333 66.773 149.333 149.333-66.773 149.333-149.333 149.333z',
            }
        ]
    },
    add: {
        view_box: '0 0 24 24',
        title: 'Add Icon',
        paths: [
            {
                value: 'M19 13h-6v6h-2v-6h-6v-2h6v-6h2v6h6v2z',
            }
        ]
    },
    bug: {
        view_box: '0 0 1024 1024',
        title: 'Bug Icon',
        paths: [
            {
                value: 'M853.333 341.333h-119.893c-19.2-33.28-45.653-62.080-77.44-83.627l69.333-69.333-60.373-60.373-92.8 92.8c-19.2-4.693-39.467-7.467-60.16-7.467s-40.96 2.773-60.16 7.467l-92.8-92.8-60.373 60.373 69.333 69.333c-31.787 21.547-58.24 50.347-77.44 83.627h-119.893v85.333h89.173c-2.347 13.867-3.84 28.16-3.84 42.667v42.667h-85.333v85.333h85.333v42.667c0 14.507 1.493 28.8 3.84 42.667h-89.173v85.333h119.893c44.16 76.373 126.72 128 221.44 128s177.28-51.627 221.44-128h119.893v-85.333h-89.173c2.347-13.867 3.84-28.16 3.84-42.667v-42.667h85.333v-85.333h-85.333v-42.667c0-14.507-1.493-28.8-3.84-42.667h89.173v-85.333zM597.333 682.667h-170.667v-85.333h170.667v85.333zM597.333 512h-170.667v-85.333h170.667v85.333z',
            }
        ]
    },
    locked: {
        view_box: '0 0 1024 1024',
        title: 'Locked Icon',
        paths: [
            {
                value: 'M808.96 409.6h-92.16v-122.88c0-148.326-68.352-235.52-204.8-235.52-136.499 0-204.8 87.194-204.8 235.52v122.88h-102.4c-28.314 0-51.2 33.075-51.2 61.389v399.411c0 28.109 21.914 58.317 48.691 66.918l61.286 19.814c26.829 8.55 71.782 15.667 99.942 15.667h296.96c28.109 0 73.114-7.117 99.891-15.718l61.235-19.814c26.829-8.55 48.794-38.758 48.794-66.867v-399.411c0-28.314-33.178-61.389-61.44-61.389zM614.4 409.6h-204.8v-143.411c0-73.984 40.806-112.589 102.4-112.589s102.4 38.605 102.4 112.589v143.411z',
            }
        ]
    },
    unlocked: {
        view_box: '0 0 1024 1024',
        title: 'Unlocked icon',
        paths: [
            {
                value: 'M808.96 409.6h-92.16v-122.88c0-148.326-68.352-235.52-204.8-235.52-136.499 0-204.8 87.194-204.8 235.52v20.48h102.4v-41.011c0-73.984 40.806-112.589 102.4-112.589s102.4 38.605 102.4 112.589v143.411h-409.6c-28.314 0-51.2 33.075-51.2 61.389v399.411c0 28.109 21.914 58.317 48.691 66.918l61.286 19.814c26.829 8.55 71.782 15.667 99.942 15.667h296.96c28.109 0 73.114-7.117 99.891-15.718l61.235-19.814c26.829-8.55 48.794-38.758 48.794-66.867v-399.411c0-28.314-33.178-61.389-61.44-61.389z',
            }
        ]
    },
    pointer: {
        view_box: '0 0 658 1024',
        title: 'Mouse pointer icon',
        paths: [
            {
                value: 'M647.429 596q17.714 17.143 8 39.429-9.714 22.857-33.714 22.857h-218.286l114.857 272q5.714 14.286 0 28t-19.429 20l-101.143 42.857q-14.286 5.714-28 0t-20-19.429l-109.143-258.286-178.286 178.286q-10.857 10.857-25.714 10.857-6.857 0-13.714-2.857-22.857-9.714-22.857-33.714v-859.429q0-24 22.857-33.714 6.857-2.857 13.714-2.857 15.429 0 25.714 10.857z',
            }
        ]
    },
    group: {
        view_box: '0 0 1024 1024',
        title: 'Group Icon',
        paths: [
            {
                value: 'M682 554q56 0 122 16t122 52 56 82v106h-256v-106q0-88-84-148 14-2 40-2zM342 554q56 0 122 16t121 52 55 82v106h-598v-106q0-46 56-82t122-52 122-16zM342 470q-52 0-90-38t-38-90 38-90 90-38 89 38 37 90-37 90-89 38zM682 470q-52 0-90-38t-38-90 38-90 90-38 90 38 38 90-38 90-90 38z',
            }
        ]
    },
    list_bulleted: {
        view_box: '0 0 1024 1024',
        title: 'Bulleted list icon',
        paths: [
            {
                value: 'M170.667 448c-35.413 0-64 28.587-64 64s28.587 64 64 64 64-28.587 64-64-28.587-64-64-64zM170.667 192c-35.413 0-64 28.587-64 64s28.587 64 64 64 64-28.587 64-64-28.587-64-64-64zM170.667 711.040c-31.36 0-56.96 25.387-56.96 56.96s25.6 56.96 56.96 56.96 56.96-25.387 56.96-56.96-25.6-56.96-56.96-56.96zM298.667 810.667h597.333v-85.333h-597.333v85.333zM298.667 554.667h597.333v-85.333h-597.333v85.333zM298.667 213.333v85.333h597.333v-85.333h-597.333z',
            }
        ]
    },
    list_numbered: {
        view_box: '0 0 1024 1024',
        title: 'Numbered list icon',
        paths: [
            {
                value: 'M85.333 725.333h85.333v21.333h-42.667v42.667h42.667v21.333h-85.333v42.667h128v-170.667h-128v42.667zM128 341.333h42.667v-170.667h-85.333v42.667h42.667v128zM85.333 469.333h76.8l-76.8 89.6v38.4h128v-42.667h-76.8l76.8-89.6v-38.4h-128v42.667zM298.667 213.333v85.333h597.333v-85.333h-597.333zM298.667 810.667h597.333v-85.333h-597.333v85.333zM298.667 554.667h597.333v-85.333h-597.333v85.333z',
            }
        ]
    },
    filter: {
        view_box: '0 0 24 24',
        title: 'Filter icon',
        paths: [
            {
                value: 'M3,2l18,0l0,2l-0.079,0l-6.921,6.921l0,11.988l-4,-4l0,-8.003l-6.906,-6.906l-0.094,0l0,-2Z',
            }
        ]
    },
    // AM App Icons
    amIcon: {
        view_box: '0 0 26 20',
        title: 'AcademicMerit A Logo',
        paths: [
            {
                value: 'M20.46 13.123c1.458 0 2.883 0.136 4.262 0.406 0.066 0.013 0.072-0.009 0.010-0.032-2.21-0.837-4.582-1.322-7.046-1.401-0.216-0.012-0.216-0.012-0.308-0.172-0.086-0.15-6.060-10.559-6.060-10.559-0.112-0.193-0.112-0.193-0.219-0.004 0 0-9.723 17.052-9.823 17.224-0.087 0.159-0.087 0.195 0.099 0.195 0.83 0 4.108 0 4.28 0 0.197 0 0.201-0.032 0.35-0.182 2.359-2.075 5.16-3.644 8.24-4.547 0.194-0.043 0.194-0.050 0.288 0.117 0.079 0.139 2.035 3.627 2.469 4.421 0.085 0.155 0.094 0.191 0.298 0.191 0.795 0 3.594 0 3.747 0 0.213 0 0.213-0.029 0.113-0.203-0.504-0.877-2.831-4.956-2.919-5.115-0.1-0.179-0.096-0.197 0.093-0.215 0.7-0.069 1.409-0.125 2.126-0.125zM11.306 8.506c0.087 0.15 1.701 2.956 2.116 3.677 0.075 0.137 0.058 0.174-0.099 0.199-1.817 0.299-3.554 0.818-5.183 1.527-0.103 0.047-0.159 0.054-0.078-0.093s0.392-0.703 0.392-0.703 2.555-4.44 2.656-4.611c0.101-0.171 0.101-0.171 0.196 0.004z',
            }
        ]
    },
    ftIcon: {
        view_box: '0 0 20 20',
        title: 'FineTune Logo',
        paths: [
            {
                value: 'M15.581 5.438l-1.912-5.131c-0.057-0.152-0.268-0.159-0.336-0.012l-0.905 1.98c-0.772-0.245-1.593-0.377-2.446-0.377-4.465 0-8.084 3.619-8.084 8.084 0 0.166 0.005 0.331 0.015 0.494 0.007 0.121 0.131 0.2 0.245 0.158l2.995-1.116c0.064-0.024 0.109-0.082 0.117-0.15 0.296-2.35 2.302-4.168 4.733-4.168 0.356 0 0.703 0.039 1.036 0.113l-0.925 2.025c-0.067 0.147 0.077 0.302 0.229 0.246l5.131-1.912c0.094-0.035 0.142-0.14 0.107-0.234zM17.813 9.455l-2.98 1.111c-0.062 0.023-0.106 0.079-0.116 0.144-0.355 2.284-2.33 4.032-4.714 4.032-0.288 0-0.57-0.026-0.844-0.075l0.901-1.972c0.067-0.147-0.077-0.303-0.229-0.246l-5.131 1.912c-0.094 0.035-0.142 0.14-0.107 0.234l1.912 5.131c0.057 0.152 0.268 0.159 0.336 0.012l0.907-1.985c0.709 0.204 1.459 0.313 2.234 0.313 4.465 0 8.084-3.619 8.084-8.084 0-0.122-0.003-0.243-0.008-0.364-0.006-0.124-0.129-0.207-0.245-0.163z',
            }
        ]
    },
    a21Icon: {
        view_box: '0 0 20 20',
        title: 'Assessments21 Logo',
        paths: [
            {
                value: 'M17.802 16.238v-12.741c0-0.101-0.082-0.183-0.183-0.183h-3.395c-0.101 0-0.183 0.082-0.183 0.183v12.741h-1.241v-10.222c0-0.101-0.082-0.183-0.183-0.183h-3.395c-0.101 0-0.183 0.082-0.183 0.183v10.222h-1.314v-6.243c0-0.101-0.082-0.183-0.183-0.183h-3.395c-0.101 0-0.183 0.082-0.183 0.183v6.243h-1.313v-14.128c0-0.101-0.082-0.183-0.183-0.183h-1.46c-0.101 0-0.183 0.082-0.183 0.183v15.954h18.070c0.141 0 0.256-0.114 0.256-0.256v-1.314c0-0.141-0.114-0.256-0.256-0.256h-1.095z',
            }
        ]
    },
    lcIcon: {
        view_box: '0 0 20 20',
        title: 'LiteraryCompanion Icon',
        paths: [
            {
                value: 'M16.498 3.476h-6.582c-0.1 0-0.182 0.081-0.182 0.182v1.818c0 0.1 0.081 0.182 0.182 0.182h4.4c0.1 0 0.182 0.081 0.182 0.182v11.309c0 0.1-0.081 0.182-0.182 0.182h-5.654c-0.083 0-0.163 0.028-0.227 0.080l-2.223 1.778c-0.134 0.107-0.058 0.324 0.114 0.324h10.173c0.1 0 0.182-0.081 0.182-0.182v-15.673c0-0.1-0.081-0.182-0.182-0.182zM9.735 7.767v1.091c0 0.1 0.081 0.182 0.182 0.182h2.982c0.1 0 0.182-0.081 0.182-0.182v-1.091c0-0.1-0.081-0.182-0.182-0.182h-2.982c-0.1 0-0.182 0.081-0.182 0.182zM9.917 12.239h2.982c0.1 0 0.182-0.081 0.182-0.182v-1.091c0-0.1-0.081-0.182-0.182-0.182h-2.982c-0.1 0-0.182 0.081-0.182 0.182v1.091c0 0.1 0.081 0.182 0.182 0.182zM9.917 15.403h2.982c0.1 0 0.182-0.081 0.182-0.182v-1.091c0-0.1-0.081-0.182-0.182-0.182h-2.982c-0.1 0-0.182 0.081-0.182 0.182v1.091c0 0.1 0.081 0.182 0.182 0.182zM8.131 0.524l-4.8 3.82c-0.043 0.035-0.069 0.087-0.069 0.142v14.844c0 0.152 0.176 0.237 0.295 0.142l4.8-3.82c0.043-0.035 0.069-0.087 0.069-0.142v-14.844c0-0.152-0.176-0.237-0.295-0.142z',
            }
        ]
    },
    circle_info: {
        view_box: '0 0 24 24',
        title: 'Information icon',
        paths: [
            {
                value: 'M11 17h2v-6h-2v6zM12 2c-5.525 0-10 4.475-10 10s4.475 10 10 10 10-4.475 10-10-4.475-10-10-10zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2v-2h-2v2z',
            }
        ]
    },
    // CB Next Steps Icons
    ns_doc: {
        view_box: '0 0 1024 1024',
        paths: [
            {
                fill: '#0099FF',
                value: "M511.4,21.2c-270.7,0.1-490,219.4-490,490c0,270.6,219.3,490,490,490c270.6,0,490-219.4,490-490C1001.3,240.5,782,21.2,511.4,21.2z M770,805H253V217h65.2h259.5L770,408.4V805Z",
            }
        ],
        shapes: [
            <rect x="318" y="324" fill="#0099FF" width="303" height="40"/>,
            <rect x="318" y="469" fill="#0099FF" width="387" height="40"/>,
            <rect x="318" y="613" fill="#0099FF" width="290" height="41"/>,
        ]
    },
    ns_doc_t: {
        view_box: '0 0 100 100',
        paths: [
            {
                value: 'M55.576,36.578l-25.517,0l0,-3.431l25.517,0l0,3.431ZM62.666,48.793l-32.607,0l0,-3.427l32.607,0l0,3.427ZM54.48,61.012l-24.421,0l0,-3.432l24.421,0l0,3.432Z',
                fill:'#478fcd',
                fillRule:'nonzero'
            }
        ],
        shapes: [
            <rect x="30.059" y="33.147" width="25.517" height="3.431" fill="#0099FF"/>,
            <rect x="30.059" y="45.366" width="32.607" height="3.427" fill="#0099FF"/>,
            <rect x="30.059" y="57.58" width="24.421" height="3.432" fill="#0099FF"/>,
        ],
        paths: [
            {
                value: 'M59.005,88.35c-3.986,1.278 -8.235,1.969 -12.646,1.969c-22.845,0 -41.359,-18.516 -41.359,-41.357c0,-22.847 18.514,-41.359 41.359,-41.362c22.846,0.003 41.36,18.515 41.364,41.362l-0.001,0.267c-0.01,1.518 -0.102,3.016 -0.271,4.491c-3.463,-2.158 -7.551,-3.404 -11.93,-3.405c-2.578,0 -5.054,0.432 -7.361,1.226l0,-11.257l-16.195,-16.141l-27.405,0l0,49.634l28.374,0c0.209,5.628 2.476,10.728 6.071,14.573Z',
                fill: '#0099FF',
            },
            {
                value: 'M95,72.92c0,10.757 -8.724,19.48 -19.48,19.48c-10.764,0 -19.484,-8.723 -19.484,-19.48c0,-10.76 8.72,-19.484 19.484,-19.484c10.756,0 19.48,8.724 19.48,19.484ZM86.303,61.75l-21.57,0l0,5.562l7.262,0l0,18.574l7.108,0l0,-18.574l7.2,0l0,-5.562Z',
                fill: '#750565'
            }
        ]
    },
    ns_doc_s: {
        view_box: '0 0 100 100',
        style: {
            fillRule:'evenodd',
            lipRule:'evenodd',
            strokeLinejoin:'round'
        },
        paths: [
            {
                value: 'M55.576,36.578l-25.517,0l0,-3.431l25.517,0l0,3.431ZM62.666,48.793l-32.607,0l0,-3.427l32.607,0l0,3.427ZM54.48,61.012l-24.421,0l0,-3.432l24.421,0l0,3.432Z',
                fill: '#0099FF',
                fillRule:'nonzero'
            },
            {
                value: 'M59.005,88.35c-3.986,1.278 -8.235,1.969 -12.646,1.969c-22.845,0 -41.359,-18.516 -41.359,-41.357c0,-22.847 18.514,-41.359 41.359,-41.362c22.846,0.003 41.36,18.515 41.364,41.362l-0.001,0.267c-0.01,1.518 -0.102,3.016 -0.271,4.491c-3.463,-2.158 -7.551,-3.404 -11.93,-3.405c-2.578,0 -5.054,0.432 -7.361,1.226l0,-11.257l-16.195,-16.141l-27.405,0l0,49.634l28.374,0c0.209,5.628 2.476,10.728 6.071,14.573Z',
                fill: '#0099FF'
            },
            {
                value: 'M95,72.92c0,10.757 -8.724,19.48 -19.48,19.48c-10.764,0 -19.484,-8.723 -19.484,-19.48c0,-10.76 8.72,-19.484 19.484,-19.484c10.756,0 19.48,8.724 19.48,19.484ZM64.86,77.522c0.626,4.176 3.761,7.464 10.807,7.464c7.135,0 10.509,-3.189 10.509,-7.596c0,-3.485 -1.552,-6.248 -9.464,-7.793c-3.284,-0.658 -4.15,-1.151 -4.15,-2.236c0,-1.085 0.866,-1.743 2.717,-1.743c2.627,0 3.195,1.184 3.433,2.203l6.628,0c-0.269,-3.42 -3.045,-6.971 -10.031,-6.971c-5.732,0 -9.643,2.663 -9.643,7.234c0,3.058 1.104,5.985 8.867,7.465c3.941,0.756 4.597,1.48 4.597,2.696c0,1.151 -0.746,1.973 -3.164,1.973c-2.747,0 -3.822,-1.151 -4.27,-2.696l-6.836,0Z',
                fill: '#e98424'
            }
        ],
        shapes: [
            <rect x="30.059" y="33.147" width="25.517" height="3.431" fill="#0099FF"/>,
            <rect x="30.059" y="45.366" width="32.607" height="3.427" fill="#0099FF"/>,
            <rect x="30.059" y="57.58" width="24.421" height="3.432" fill="#0099FF"/>,
        ],
    },
    ns_learning: {
        view_box: '0 0 1024 1024',
        paths: [
            {
                fill: '#0099FF',
                value: 'M512.4,17.9c-270.7,0-490,219.4-490,490c0,270.6,219.3,490,490,490c270.6,0,489.9-219.4,490-490C1002.3,237.3,783,18,512.4,17.9z M566.3,877.6c-9.1,8.9-21.6,14.5-35.4,14.5h-34.3c-13.8,0-26.3-5.6-35.3-14.5c-7.7-7.5-12.1-17.8-13.7-28.9h132.3C578.4,859.7,573.8,870,566.3,877.6z M656.7,780.2c0,8.1-3.3,15.6-8.7,21c-5.3,5.4-12.8,8.6-20.9,8.6h-47.2H447.6h-47.1c-8.2,0-15.7-3.3-21-8.7c-5.4-5.3-8.7-12.8-8.7-21v-0.6l0.1-0.4v-40.5h285.7v40.5l0.1,0.3L656.7,780.2z M755.7,466.6c-10.8,23.9-24.9,45.2-38.6,65.9c-14.5,22.1-29.2,44.1-40,69.3c-10.9,25.2-18.2,53.3-18.2,88v6.3H369.3v-6.3c0-32.2-6.9-58.3-17.6-82c-10.6-23.7-25.1-45.1-40.2-67.4c-14.6-21.5-29.7-43.6-41.2-68.7c-11.5-25.1-19.3-53.2-19.3-86.2c0-72.1,29.3-137.5,76.7-184.8c47.3-47.4,112.7-76.7,184.8-76.7c72.1,0,137.5,29.3,184.8,76.7c47.3,47.3,76.6,112.8,76.6,184.8C773.8,416.1,766.5,442.7,755.7,466.6Z',
            },
            {
                fill: '#0099FF',
                value: 'M498.8,206.4v-0.9l-6.3,0.1c-43.5,0.7-84.4,18-115.2,48.9v0l-0.1,0.1v0c-31.1,31.1-48.5,72.5-48.9,116.4v0.2l-0.1,6.3h1.2c0.8,2.7,2.1,5.2,4,7.1c3.1,3.1,7.5,5,12.2,5c4.7,0,9-1.9,12.1-5c3.2-3.1,5-7.5,5-12.2c0-32.8,11.9-63.8,33.7-88.1l0.2-0.3l0.1,0l1.7-1.9v0l0.6-0.7l0.1,0l1.4-1.5l1-1.1h0.1l0.9-1l1.5-1.5l0.7-0.6l-0.1,0l1.9-1.8l0.3-0.2c24.4-21.8,55.3-33.7,88.2-33.7c4.7,0,9.1-2,12.1-5.1c3.2-3.1,5.1-7.4,5.1-12.2c0-4.7-1.9-9.1-5.1-12.1C505.1,208.4,502.1,207.1,498.8,206.4Z',
            }
        ]
    },
    ns_link: {
        view_box: '0 0 1024 1024',
        paths: [
            {
                fill: '#0099FF',
                value: 'M512.4,18.8c-270.7,0-490,219.4-490,490c0,270.6,219.3,490,490,490c270.6,0,490-219.4,490-490C1002.3,238.1,783,18.8,512.4,18.8z M743.8,484.3l-0.3,231.6L596.3,568.6l-6.4-6.4l-27-26.9c-80.4,30.9-155.6,97.4-81.2,260.7c0,0-268.2-142.3-56.2-398.3l-18.9-18.9L280.8,253.2l231.5-0.4l231.6-0.2L743.8,484.3Z',
            }
        ]
    },
    ns_video: {
        view_box: '0 0 1024 1024',
        paths: [
            {
                fill: '#0099FF',
                value: 'M512.4,18.2c-270.7,0-490,219.3-490,490c0,270.7,219.4,490,490,490c270.6,0,490-219.3,490-490C1002.3,237.6,783,18.2,512.4,18.2z M567.5,617.2L343.9,719.4V514.8V310.2l223.5,102.3L791,514.8L567.5,617.2Z',
            }
        ]
    },
    ns_strategy: {
        view_box: '0 0 1024 1024',
        paths: [
            {
                fill: '#e98424',
                value: 'M1002,512.015c0,270.523 -219.447,489.94 -489.97,489.94c-270.735,0 -490.03,-219.417 -490.03,-489.94c0,-270.704 219.295,-489.97 490.03,-489.97c270.523,0 489.97,219.266 489.97,489.97ZM243.928,627.791c15.771,105.041 94.616,187.746 271.827,187.746c179.465,0 264.317,-80.227 264.317,-191.055c0,-87.67 -39.047,-157.144 -238.036,-196.017c-82.599,-16.541 -104.375,-28.947 -104.375,-56.241c0,-27.293 21.776,-43.835 68.332,-43.835c66.079,0 80.346,29.775 86.354,55.414l166.7,0c-6.758,-86.016 -76.592,-175.34 -252.303,-175.34c-144.174,0 -242.542,66.993 -242.542,181.957c0,76.918 27.783,150.528 223.018,187.746c99.119,19.023 115.639,37.218 115.639,67.82c0,28.948 -18.772,49.625 -79.595,49.625c-69.081,0 -96.114,-28.946 -107.38,-67.82l-171.956,0Z',
            }
        ]
    },
    full_form: {
        view_box: '0 0 516 616',
        title: 'Full Form Icon',
        paths: [
            {
                id: "Combined-Shape",
                value: "M71,5.68434189e-14 L29.9963096,5.68434189e-14 C13.4376692,5.68434189e-14 0,13.4302792 0,29.9973681 L0,586.002632 C0,602.561087 13.4298053,616 29.9963096,616 L71,616 L71,-5.32907052e-15 Z M115,5.68434189e-14 L486.00369,5.68434189e-14 C502.570195,5.68434189e-14 516,13.4389132 516,29.9973681 L516,586.002632 C516,602.569721 502.562331,616 486.00369,616 L115,616 L115,5.68434189e-14 Z M426.113281,127 L180,127 L180,171 L426.113281,171 L426.113281,127 Z M426.113281,236 L180,236 L180,280 L426.113281,280 L426.113281,236 Z",
            }
        ]
    },
    chevron_left: {
    view_box: "0 0 11 20",
        shapes: [
            <polygon key={1} points="10.8071068 2.12110678 9.39289322 0.706893219 0.200786438 9.899 9.39389322 19.0921068 10.8081068 17.6778932 3.02921356 9.899"></polygon>
        ]
    },
    chevron_right: {
        view_box: '0 0 11 20',
        title: 'Chevron pointing right',
        shapes: [
            <polygon key={1} transform="translate(5.504447, 9.899500) scale(-1, 1) translate(-5.504447, -9.899500) " points="10.8071068 2.12110678 9.39289322 0.706893219 0.200786438 9.899 9.39389322 19.0921068 10.8081068 17.6778932 3.02921356 9.899"></polygon>
        ]
    },
}

export {icons};



/** WEBPACK FOOTER **
 ** core/client/rawr/style/Icon.jsx
 **/